import React from 'react';
import { Section } from './ui/Section';
import { Clock, Smartphone, Heart } from 'lucide-react';
export function Problem() {
  return <Section className="bg-white" data-id="element-87">
      <div className="space-y-8" data-id="element-88">
        <div className="prose prose-lg mx-auto text-gray-600" data-id="element-89">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-90">
            Imagínate esto...
          </h2>
          <p className="text-lg leading-relaxed mb-6" data-id="element-91">
            Estás en tu casa, con tus hijos cerca, y mientras revisas tu
            WhatsApp te entra un mensaje:{' '}
            <span className="font-semibold text-emerald-600 bg-emerald-50 px-1 rounded" data-id="element-92">
              "Ya hice el pago, ¿me mandas la guía?"
            </span>
          </p>
          <p className="text-lg leading-relaxed mb-6" data-id="element-93">
            En unos minutos, desde el mismo celular con el que ves memes y
            hablas con tu familia, envías un PDF que creaste tú… y acabas de
            generar un ingreso sin salir de casa.
          </p>
          <p className="text-lg leading-relaxed font-medium text-rose-700 bg-rose-50 p-6 rounded-xl border border-rose-100" data-id="element-94">
            No es un sueño ni una promesa exagerada. Es simplemente usar lo que
            ya tienes —tu experiencia, tu celular y tus chats— de una forma
            distinta.
          </p>
        </div>

        <div className="mt-12 bg-gray-50 rounded-2xl p-8 md:p-10 border border-gray-100" data-id="element-95">
          <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-96">
            El problema es que...
          </h3>
          <p className="text-gray-600 mb-8" data-id="element-97">
            Todo lo que ves sobre "negocios digitales" parece hecho para gente
            con mucho tiempo, sin hijos, con computadoras carísimas y palabras
            raras.
          </p>

          <div className="grid gap-6 md:grid-cols-3" data-id="element-98">
            <div className="flex flex-col items-center text-center p-4" data-id="element-99">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center text-rose-600 mb-4" data-id="element-100">
                <Clock className="w-6 h-6" data-id="element-101" />
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-102">¿Tiempo?</p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-103">
                Entre pañales, escuela y casa no sobra nada.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-104">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center text-rose-600 mb-4" data-id="element-105">
                <Smartphone className="w-6 h-6" data-id="element-106" />
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-107">¿Tecnología?</p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-108">
                Solo tienes tu celular, nada de equipos caros.
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-109">
              <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center text-rose-600 mb-4" data-id="element-110">
                <Heart className="w-6 h-6" data-id="element-111" />
              </div>
              <p className="text-sm font-medium text-gray-800" data-id="element-112">¿Prioridades?</p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-113">
                Tus hijos son lo primero, no puedes descuidarlos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}